const Radio = {
  parts: ["control"],
  baseStyle: { control: { borderColor: "gray.500" } },
};

export default Radio;
